import React from 'react';

const DownloadButton = ({ groupType, buttonType, color }) => {
    return (
        <div className={`download-button-group ${groupType}`}>
            <a href="/contact" className={`download-button download-button-google ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className={`download-button-icon c-green ${color}`}>
                        <i className="fab fa-envira"></i>
                    </div>
                    <div className="download-button-content">
                        <h5 className={`c-grey upper ls-1 ${color}`}>Environment</h5>
                        <h3 className={`c-dark ls-2 ${color}`}>Green Pill</h3>
                    </div>
                </div>
            </a>
            <a href="/contact" className={`download-button download-button-apple ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className={`download-button-icon c-blue ${color}`}>
                        <i className="fa fa-microchip "></i>
                    </div>
                    <div className="download-button-content">
                        <h5 className={`c-grey upper ls-1 ${color}`}>Technology</h5>
                        <h3 className={`c-dark ls-2 ${color}`}>Blue Pill</h3>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default DownloadButton;
